import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { AuthenticatedAppRoutes } from '../AppRoutes';

export const useSamplesLink = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const sampleLink = useCallback(
    (sampleId: string, step?: number) =>
      `${AuthenticatedAppRoutes.SampleRoute.link(sampleId)}${step ? `?etape=${step}` : ''}`,
    []
  );

  const samplesLink = useCallback(
    (year: number) => AuthenticatedAppRoutes.SamplesByYearRoute.link(year),
    []
  );

  const navigateToSample = (sampleId: string, step?: number) => {
    const currentParams = new URLSearchParams(location.search);
    const isEditing = currentParams.get('isEditing');
    const newParams = new URLSearchParams();
    if (step) {
      newParams.set('etape', String(step));
    }
    if (isEditing) {
      newParams.set('isEditing', isEditing);
    }
    const queryString = newParams.toString();
    navigate(
      `${AuthenticatedAppRoutes.SampleRoute.link(sampleId)}${queryString ? `?${queryString}` : ''}`
    );
  };

  const navigateToSampleEdit = (sampleId: string) => {
    const search = location.search;
    navigate(
      `${AuthenticatedAppRoutes.SampleAnalysisEditRoute.link(sampleId)}${search}`
    );
  };

  const navigateToSamples = (year: number) => {
    navigate(samplesLink(year) as string);
  };

  const getSampleStepParam = useCallback(() => {
    const params = new URLSearchParams(location.search);
    const stepParam = params.get('etape');
    if (stepParam) {
      return Number(stepParam);
    }
    return;
  }, [location.search]);

  return {
    sampleLink,
    navigateToSample,
    navigateToSampleEdit,
    samplesLink,
    navigateToSamples,
    getSampleStepParam
  };
};
